var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.title}}),_c('page-body',[_c('list',{key:_vm.res_type,attrs:{"listId":"MonitorresourcesList","res_type":_vm.res_type}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }